import svg1 from "../../../../lib/assets/rowIcons/1.1v1.svg";
import svg2 from "../../../../lib/assets/rowIcons/2.1v2.svg";
import svg3 from "../../../../lib/assets/rowIcons/3.xv1.svg";
import svg4 from "../../../../lib/assets/rowIcons/4.1vx.svg";
import svg5 from "../../../../lib/assets/rowIcons/5.xy1.svg";
import svg6 from "../../../../lib/assets/rowIcons/6.x1y.svg";
// eslint-disable-next-line @typescript-eslint/naming-convention
export const icons = [svg1, svg2, svg3, svg4, svg5, svg6];